<template>
  <component
    :is="props.wrapper || label ? 'div' : QIcon"
    class="tw-relative hover:tw-cursor-pointer"
    :class="{
      'c-tooltip-standalone--icon': isIcon,
      'tw-text-gray-500': isIcon,
    }"
    :name="name"
    size="16px"
    v-bind="$attrs"
  >
    {{ label }}
    <c-tooltip>
      <slot />
    </c-tooltip>
  </component>
</template>

<script setup>
import { infoIcon, toClassicIcon } from "common/defaultIcons";
import { QIcon } from "quasar";
import { computed } from "vue";

const props = defineProps({
  name: {
    type: String,
    default: toClassicIcon(infoIcon),
  },
  label: {
    type: String,
    default: "",
  },
  wrapper: {
    type: Boolean,
    default: false,
  },
});

const isIcon = computed(() => props.wrapper === false && props.label === "");
</script>

<style scoped>
.c-tooltip-standalone--icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  font-size: 16px !important;
}
</style>
